import {HStack, Text} from 'platform/foundation';

interface KeyFigureValueProps {
  label: string;
  value: string;
}

export function KeyFigureValue(props: KeyFigureValueProps) {
  return (
    <HStack justify="space-between" spacing={2}>
      <Text size="small" color="secondary">
        {props.label}
      </Text>
      <Text size="small" alternative>
        {props.value}
      </Text>
    </HStack>
  );
}
